<template>
	<div class="header-icon help-icon">
		<button @click="showModal">
			<font-awesome-icon icon="comments" />
			<p>Help</p>
		</button>

		<modal v-if="isModalVisible" @close="closeModal" @backgroundClicked="closeModal">
			<h2 slot="header">Key Contact Information</h2>
			<div slot="body">
				<div class="container">
					<section>
						<h3>System enquiries</h3>
						<ul class="no-style-list">
							<li><strong>Gary Edwards</strong></li>
							<li>Head of Marketing &amp; Systems</li>
							<li>Internal: ext. 2050</li>
							<li>External: 01204 555071</li>
							<li><a href="mailto:edwards@k3capitalgroupplc.com">edwards@k3capitalgroupplc.com</a></li>
						</ul>
					</section>

					<section>
						<h3>Data enquiries</h3>
						<ul class="no-style-list">
							<li><strong>Amy Oakes</strong></li>
							<li>Data Analyst</li>
							<li>Internal: ext. 2082</li>
							<li>External: 01204 555071</li>
							<li><a href="mailto:oakes@kbscorporate.com">oakes@kbscorporate.com</a></li>
						</ul>
					</section>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import Modal from '../reusable/Modal'

	export default {
		name: 'HelpIcon',
		data() {
			return {
				isModalVisible: false
			}
		},
		components: {
			FontAwesomeIcon,
			Modal
		},
		methods: {
			showModal() {
				this.isModalVisible = true
			},
			closeModal() {
				this.isModalVisible = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	button {
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
		text-align:center;
	}

	button:hover {
		p{
			text-decoration: underline;
		}
	}

	.container{
		display:flex;

		section{
			flex-grow:1;
		}

		li{
			margin-bottom:20px;
		}

		section:nth-of-type(1){
			margin-right:40px;
		}

		section:nth-of-type(2){
			margin-left:40px;
		}

		a{
			color:#38B7EA;
		}

		@media only screen and (max-width: 800px){
			display:block;

			section{
				margin-left:0 !important;
			}

			section:nth-of-type(2){
				margin-top:40px;
			}
		}
	}
</style>
